import { IPersonState } from './IPersonState'

export const initialState: IPersonState = {
    loading: false,
}
